import { render, staticRenderFns } from "./SlideSelectSerial.vue?vue&type=template&id=798389c3&scoped=true"
import script from "./SlideSelectSerial.vue?vue&type=script&lang=js"
export * from "./SlideSelectSerial.vue?vue&type=script&lang=js"
import style0 from "./SlideSelectSerial.vue?vue&type=style&index=0&id=798389c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798389c3",
  null
  
)

export default component.exports